import { render, staticRenderFns } from "./DictionaryWordsRecent.vue?vue&type=template&id=872c10d8&scoped=true&"
import script from "./DictionaryWordsRecent.vue?vue&type=script&lang=js&"
export * from "./DictionaryWordsRecent.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryWordsRecent.vue?vue&type=style&index=0&id=872c10d8&scoped=true&lang=scss&"
import style1 from "./DictionaryWordsRecent.vue?vue&type=style&index=1&id=872c10d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c10d8",
  null
  
)

export default component.exports